module.exports = __webpack_public_path__ + "img/home.23b9863a.svg";